import { useState } from "react";
import BotFileUploadStyles from "./BotFileUpload.module.scss";
import UploadSVG from "../../../../../assets/upload_grey.svg";
import { useAppSelector } from "../../../../../hooks/store";
import Tooltip from "../../../../../components/Tooltip/Tooltip";
import PDFIcon from "../../../../../assets/pdfIcon.svg";
import DocIcon from "../../../../../assets/docIcon.svg";

 export const determineIconUrl = (mimeTypeOrName: string) => {
  if (!mimeTypeOrName) return DocIcon;
  const lower = mimeTypeOrName.toLowerCase();
  if (lower === 'application/pdf' || lower.endsWith('.pdf')) {
    return PDFIcon;
  }
  return DocIcon;
};

const BotFileUpload = () => {
  const { vmoBot } = useAppSelector(
    (store) => store.rootReducer.vscDashboardReducer
  );
  const { processingStage, uploadingState, uploadedFiles } = vmoBot?.fileUpload;
  const [showAllFiles, setShowAllFiles] = useState(false);

  const handleViewAll = () => {
    setShowAllFiles(!showAllFiles);
  };

  return (
    <div className={BotFileUploadStyles.wrapper}>
      {/* <ChatMessage
        message={{
          sender: "bot",
          text: "Please choose a contract that requires action",
        }}
      /> */}
      {processingStage === "SelectFiles" ? (
        <></>
      ) : (
        <div
          className={`${BotFileUploadStyles.uploadedFiles} ${
            showAllFiles ? `${BotFileUploadStyles.viewAllFiles}` : ""
          } `}
        >
          {!showAllFiles && uploadedFiles?.length > 3 ? (
            <>
              {uploadedFiles?.slice(0, 3).map((file: any) => {
                return (
                  <Tooltip title={file?.name}>
                    <div
                      className={`${BotFileUploadStyles.fileFlag} ${
                        uploadingState ? `${BotFileUploadStyles.active}` : ""
                      } `}
                    >
                      <img src={file?.iconUrl} alt="" />
                      <p>{file?.name}</p>
                      {uploadingState && <img src={UploadSVG} alt="" />}
                    </div>
                  </Tooltip>
                );
              })}
              <div
                className={BotFileUploadStyles.viewAll}
                onClick={handleViewAll}
              >
                <p>+ {uploadedFiles?.length - 3} More</p>
              </div>
            </>
          ) : (
            <>
              {" "}
              {uploadedFiles.map((file: any) => {
                return (
                  <Tooltip title={file?.name}>
                    <div
                      className={`${BotFileUploadStyles.fileFlag} ${
                        uploadingState ? `${BotFileUploadStyles.active}` : ""
                      } `}
                    >
                      <img src={file?.iconUrl} alt="" />
                      <p>{file?.name}</p>
                      {uploadingState && <img src={UploadSVG} alt="" />}
                    </div>
                  </Tooltip>
                );
              })}
              {uploadedFiles.length > 3 && (
                <div
                  className={BotFileUploadStyles.viewAll}
                  onClick={handleViewAll}
                >
                  <p>Show less</p>
                </div>
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default BotFileUpload;
